import { objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback } from 'react';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';
import { useContextSelector } from 'use-context-selector';
import { useSnackbar } from '@bucketplace/design-system';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../../contexts/internal/EditorContext.js';
import { useImageMapBrazeContext } from '../../../contexts/external/ImageMapBrazeContext.js';
import { useEditorInfoContext } from '../../../contexts/external/EditorInfoContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../../components/FormContent.js';

var _excluded = ["children"];
function ImageMapBrazeButton(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(BrazeButton, props, children || jsx(EditorPlaceholder, {
    icon: jsx(BsLink45Deg, null),
    message: "\uC544\uC774\uD15C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
  }));
}
function BrazeButton(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style,
    customEventName = _ref2.customEventName,
    url = _ref2.url,
    message = _ref2.message,
    logData = _ref2.logData;
  var _useSnackbar = useSnackbar(),
    openSnackbar = _useSnackbar.open;
  var _useImageMapBrazeCont = useImageMapBrazeContext(),
    isLoggedIn = _useImageMapBrazeCont.isLoggedIn,
    onClick = _useImageMapBrazeCont.onClick,
    onSignin = _useImageMapBrazeCont.onSignin;
  var _useEditorInfoContext = useEditorInfoContext(),
    onSendLog = _useEditorInfoContext.onSendLog;
  var _useContextSelector = useContextSelector(EditorContext, function (context) {
      return context.state;
    }),
    displayMode = _useContextSelector.displayMode;
  var handleClick = useCallback(function () {
    if (displayMode === 'edit' || !customEventName) {
      return;
    }

    /**
     * 로그인 유저만 braze 전송합니다.
     * 로그인 유저이면서 url 없으면 snackbar 노출합니다.
     */
    if (!isLoggedIn) {
      onSignin === null || onSignin === void 0 || onSignin();
      return;
    }
    onClick === null || onClick === void 0 || onClick(customEventName !== null && customEventName !== void 0 ? customEventName : '');
    if (logData) {
      onSendLog === null || onSendLog === void 0 || onSendLog(logData);
    }
    if (!url) {
      openSnackbar({
        content: message || '신청이 완료되었습니다.'
      });
    }
  }, [displayMode, customEventName, onClick]);
  if (url) {
    return jsx("a", {
      href: url,
      className: className,
      style: style,
      onClick: handleClick
    }, children);
  }
  return jsx("button", {
    type: "button",
    onClick: handleClick,
    className: className,
    style: style
  }, children);
}

export { ImageMapBrazeButton };
//# sourceMappingURL=ImageMapBrazeButton.js.map
